import { Box } from "@mui/material";
import AndOrFilter from "../../../../components/filters/AndOrFilter";
import FilterMenu from "../../../../components/filters/FilterMenu";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { DataStoreResourceTypeIconsAndLabels } from "../utils";
import { ALL_OPTION_NAME, filterName } from "./utils";

const getDatastoreTypeOptions = (fetchedEntities) => {
  const types = new Set(
    fetchedEntities?.map((entity) => entity?.resource_type).filter(Boolean)
  );
  return [
    {
      name: ALL_OPTION_NAME,
      label: "All datastore types",
      displayName: "All",
    },
    ...Array.from(types).map((type) => {
      if (!DataStoreResourceTypeIconsAndLabels[type]) {
        // Provide a fallback for types that don't have an icon defined
        return {
          name: type,
          label: type,
          displayName: type,
        };
      }

      const [Icon, label] = DataStoreResourceTypeIconsAndLabels[type];
      return {
        name: type,
        label: (
          <Box display="flex" gap={1} alignItems="center">
            <SvgToIcon IconLogo={Icon} width={"18px"} />
            {label}
          </Box>
        ),
        displayName: label,
      };
    }),
  ];
};

export const backupOption = {
  ENABLED: "Enabled",
  DISABLED: "Disabled",
};

const backupOptions = [
  {
    name: backupOption.ENABLED,
    label: backupOption.ENABLED,
    displayName: backupOption.ENABLED,
  },
  {
    name: backupOption.DISABLED,
    label: backupOption.DISABLED,
    displayName: backupOption.DISABLED,
  },
];

export const publicAccessOption = {
  PUBLIC_READ: "publicRead",
  PUBLIC_WRITE: "publicWrite",
};

export const publicAccessOptionDisplayName = {
  [publicAccessOption.PUBLIC_READ]: "Public Read",
  [publicAccessOption.PUBLIC_WRITE]: "Public Write",
};

export const publicAccessOptions = [
  {
    name: publicAccessOption.PUBLIC_READ,
    label: "Public Read",
    displayName: publicAccessOptionDisplayName[publicAccessOption.PUBLIC_READ],
  },
  {
    name: publicAccessOption.PUBLIC_WRITE,
    label: "Public Write",
    displayName: publicAccessOptionDisplayName[publicAccessOption.PUBLIC_WRITE],
  },
];

export const getDatastoreFilters = (params) => [
  <FilterMenu
    filterName={"Type"}
    fieldName={filterName.DATASTORE_TYPE}
    options={getDatastoreTypeOptions(params.fetchedEntities)}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
  />,
  <FilterMenu
    filterName={"Backup"}
    fieldName={filterName.BACKUP}
    options={backupOptions}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
  />,
  <AndOrFilter
    filterName={"Public Access"}
    fieldName={filterName.PUBLIC_ACCESS}
    options={publicAccessOptions}
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
    setFilterLogic={params.setFilterAndOrLogics}
  />,
];
